import React, { useCallback } from 'react';
import { Text, StyleSheet } from 'react-native';

export default function CustomText(props) {

    return (
        <Text style={[styles.defaultStyle, props.style]}>
            {props.children}
        </Text>
    );
}

const styles = StyleSheet.create({
    defaultStyle: {
        fontSize: 16,
        fontFamily: 'Roboto-Medium',
    },
});